import moment from "moment";
import { Cell } from "react-table";
import { CustomLinkModel } from "src/api/customLink/custom-link-types";
import { BaseTooltip } from "src/components";
import BaseNewTabLink from "src/components/BaseNewTabLink";
import DetailLink from "src/components/DetailLink";
import PagePath from "src/pagePath.json";
import { ViewYmdFormat } from "src/utils";
import icGlobe from "src/assets/images/ic_globe.svg";
/* 
  외부링크 예약 목록 columns
*/
const columns = [
  {
    Header: "링크 ID",
    accessor: "id",
    width: 120,
    Cell: ({ value }: Cell<CustomLinkModel>) => {
      const detailPath = `${PagePath.customLink.detail.replace(":id", `${value}`)}`;
      return (
        <div>
          <DetailLink className="text-underline" to={`${detailPath}`}>
            {value}
          </DetailLink>
        </div>
      );
    },
  },
  {
    Header: "아이콘",
    accessor: "iconMedia",
    width: 80,
    Cell: ({ row, value }: Cell<CustomLinkModel>) => {
      const iconMedia = row.original.icon?.url;
      return <div className="custom-link-list-icon">
        <img src={iconMedia || icGlobe} className="custom-link-list-icon__icon" alt="custom-link-list-icon" />
      </div>;
    },
  },
  {
    Header: "링크명",
    accessor: "name",
    width: 240,
    Cell: ({ value }: Cell<CustomLinkModel>) => {
      return <BaseTooltip className="text-left w-100" isSingleLine contents={value || "-"} />;
    },
  },
  {
    Header: "링크 설명",
    accessor: "description",
    width: 200,
    Cell: ({ value }: Cell<CustomLinkModel>) => {
      return <BaseTooltip className="text-left w-100" isSingleLine contents={value || "-"} />;
    },
  },
  {
    Header: "링크",
    accessor: "url",
    width: 200,
    Cell: ({ value }: Cell<CustomLinkModel>) => {
      return (
        <div className="w-100">
          <BaseNewTabLink path={value} value={value || "-"} ellipsis />
        </div>
      );
    },
  },

  {
    Header: "노출 여부",
    accessor: "exposed",
    width: 80,
    align: "center",
    Cell: ({ value }: Cell<CustomLinkModel>) => {
      return <>{value ? "노출" : "노출 안함"}</>;
    },
  },
  {
    Header: "노출 순서",
    accessor: "priority",
    width: 80,
    align: "center",
    Cell: ({ value, row, rows }: any) => {
      // priority가 있는 항목들만 필터링하고 내림차순 정렬
      const itemsWithPriority = rows
        .map((r: any) => r.original)
        .filter((item: CustomLinkModel) => item.priority !== null && item.priority !== undefined)
        .sort((a: CustomLinkModel, b: CustomLinkModel) => (b.priority || 0) - (a.priority || 0));

      // 현재 항목의 priority로 정렬된 배열에서의 인덱스 찾기
      const currentIndex = itemsWithPriority.findIndex((item: CustomLinkModel) => item.id === row.original.id);

      // priority가 있으면 순서 표시 (1부터 시작), 없으면 "-"
      if (value !== null && value !== undefined && currentIndex !== -1) {
        return <>{currentIndex + 1}</>;
      }
      return <>-</>;
    },
  },
  {
    Header: "최종 수정일시",
    accessor: "lastModifiedDate",
    width: 160,
    align: "center",
    // ISO 8601 표준(YYYY-MM-DD HH:mm:ss), 당일 여부와 관계없이 날짜+시간 항상 노출 (호버 제거)
    Cell: ({ value }: Cell<CustomLinkModel>) => <span>{value ? moment(value).format(ViewYmdFormat.FULL) : "-"}</span>,
  },
];

export default columns;
